import { SvgIcon } from '@mui/material';

const Paperless = () => (
  <SvgIcon
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 96, height: 96, fill: 'none' }}
    data-testid="paperlessIcon"
  >
    <path
      d="M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z"
      fill="#F7F8FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.3725 18.4336H69.9525C72.4049 18.4336 74.3893 20.5526 74.3987 23.1714V55.8332C71.8247 54.1105 68.7295 53.1058 65.3996 53.1058C56.4526 53.1058 49.1996 60.3588 49.1996 69.3058C49.1996 74.9201 52.0555 79.8673 56.3938 82.7739H27.3725C24.9201 82.7739 22.9263 80.6549 22.9263 78.0361V23.1714C22.9263 20.5526 24.9201 18.4336 27.3725 18.4336Z"
      fill="#CFD2E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.3725 20.8464H69.9525C70.9238 20.8464 71.979 21.7325 71.9859 23.1764V54.5007C72.8308 54.8771 73.6375 55.3238 74.3987 55.8332V23.1714C74.3893 20.5526 72.4049 18.4336 69.9525 18.4336H27.3725C24.9201 18.4336 22.9263 20.5526 22.9263 23.1714V78.0361C22.9263 80.6549 24.9201 82.7739 27.3725 82.7739H56.3938C55.3578 82.0798 54.4063 81.2693 53.5581 80.3612H27.3725C26.393 80.3612 25.3391 79.4672 25.3391 78.0361V23.1714C25.3391 21.7403 26.393 20.8464 27.3725 20.8464Z"
      fill="#4D5160"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.2458 12.3057H63.8259C66.2783 12.3057 68.2627 14.4247 68.272 17.0435V53.3595C67.3397 53.1927 66.3797 53.1056 65.3993 53.1056C56.4523 53.1056 49.1993 60.3586 49.1993 69.3056C49.1993 71.9479 49.8319 74.4425 50.9539 76.6461H21.2458C18.7934 76.6461 16.7997 74.527 16.7997 71.9083V17.0435C16.7997 14.4247 18.7934 12.3057 21.2458 12.3057Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5279 14.3438H62.0941C63.0423 14.3438 64.0723 15.2047 64.0791 16.6073V53.1588C64.5145 53.1237 64.9547 53.1058 65.3991 53.1058C65.7469 53.1058 66.0921 53.1167 66.4344 53.1383V16.6025C66.4253 14.0585 64.4881 12 62.0941 12H22.979C20.585 12 17.4131 14.0585 17.4131 16.6025V69.8997C17.4131 72.4437 19.3594 74.5021 21.7534 74.5021H50.0505C49.7941 73.7445 49.5922 72.9616 49.4495 72.1583H20.5279C19.5717 72.1583 18.5429 71.2899 18.5429 69.8997V16.6025C18.5429 15.2123 19.5717 14.3438 20.5279 14.3438Z"
      fill="#B6D6F7"
    />
    <g clipPath="url(#clip0_6471_16664)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.0012 82.6006C73.1809 82.6006 79.0012 76.7803 79.0012 69.6006C79.0012 62.4209 73.1809 56.6006 66.0012 56.6006C58.8215 56.6006 53.0012 62.4209 53.0012 69.6006C53.0012 76.7803 58.8215 82.6006 66.0012 82.6006Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.0013 80.4238C71.9788 80.4238 76.8245 75.5781 76.8245 69.6006C76.8245 63.6231 71.9788 58.7773 66.0013 58.7773C60.0238 58.7773 55.178 63.6231 55.178 69.6006C55.178 75.5781 60.0238 80.4238 66.0013 80.4238ZM79.0013 69.6006C79.0013 76.7803 73.181 82.6006 66.0013 82.6006C58.8216 82.6006 53.0013 76.7803 53.0013 69.6006C53.0013 62.4209 58.8216 56.6006 66.0013 56.6006C73.181 56.6006 79.0013 62.4209 79.0013 69.6006Z"
        fill="#55D18F"
      />
      <g clipPath="url(#clip1_6471_16664)">
        <path
          d="M73.0241 63.4527C73.0123 63.252 72.9272 63.0626 72.785 62.9205C72.6429 62.7783 72.4535 62.6933 72.2528 62.6815C69.5373 62.5219 67.1378 62.8416 65.1214 63.6321C63.1927 64.3883 61.7053 65.5607 60.8198 67.0227C59.611 69.0184 59.6086 71.4421 60.7894 73.7552L59.5843 74.9604C59.4324 75.1147 59.3477 75.3229 59.3486 75.5394C59.3495 75.756 59.4359 75.9634 59.589 76.1166C59.7421 76.2697 59.9496 76.3561 60.1661 76.357C60.3827 76.3579 60.5908 76.2731 60.7452 76.1213L61.9503 74.9162C63.0985 75.5023 64.2737 75.7976 65.4106 75.7976C66.5646 75.801 67.697 75.4854 68.6828 74.8857C70.1448 74.0003 71.3172 72.5128 72.0733 70.5842C72.8639 68.5677 73.1837 66.1684 73.024 63.4527H73.0241ZM67.8323 73.4814C66.4532 74.3168 64.8318 74.3797 63.1839 73.6826L68.9541 67.9123C69.106 67.7579 69.1908 67.5498 69.1899 67.3332C69.189 67.1166 69.1026 66.9092 68.9494 66.7561C68.7963 66.6029 68.5889 66.5165 68.3723 66.5156C68.1558 66.5148 67.9476 66.5995 67.7933 66.7514L62.0229 72.5217C61.3259 70.8737 61.3888 69.2523 62.2241 67.8733C63.6586 65.5047 67.0631 64.1886 71.4157 64.2898C71.5175 68.6415 70.2008 72.0469 67.8323 73.4815V73.4814Z"
          fill="#55D18F"
        />
      </g>
    </g>
    <path
      d="M60.5706 28.999H25.6162C25.1454 28.999 24.7637 29.3807 24.7637 29.8516C24.7637 30.3224 25.1454 30.7041 25.6162 30.7041H60.5706C61.0414 30.7041 61.4231 30.3224 61.4231 29.8516C61.4231 29.3807 61.0414 28.999 60.5706 28.999Z"
      fill="#878C9D"
    />
    <path
      d="M49.3852 34.9668C49.3852 35.4377 49.0035 35.8194 48.5326 35.8194H47.5011C47.0302 35.8194 46.6485 35.4377 46.6485 34.9668C46.6485 34.496 47.0302 34.1143 47.5011 34.1143H48.5326C49.0035 34.1143 49.3852 34.496 49.3852 34.9668ZM43.9119 34.9668C43.9119 35.4377 43.5302 35.8194 43.0593 35.8194H42.0277C41.5569 35.8194 41.1752 35.4377 41.1752 34.9668C41.1752 34.496 41.5569 34.1143 42.0277 34.1143H43.0593C43.5302 34.1143 43.9119 34.496 43.9119 34.9668ZM38.4044 34.9668C38.4044 35.4377 38.0227 35.8194 37.5518 35.8194H36.5288C36.058 35.8194 35.6762 35.4377 35.6762 34.9668C35.6762 34.496 36.058 34.1143 36.5288 34.1143H37.5518C38.0227 34.1143 38.4044 34.496 38.4044 34.9668ZM32.9396 34.9668C32.9396 35.4377 32.5579 35.8194 32.0871 35.8194H31.0555C30.5846 35.8194 30.2029 35.4377 30.2029 34.9668C30.2029 34.496 30.5846 34.1143 31.0555 34.1143H32.0871C32.5579 34.1143 32.9396 34.496 32.9396 34.9668ZM27.483 34.9839C27.4737 35.448 27.0948 35.8194 26.6306 35.8194H25.6162C25.1454 35.8194 24.7637 35.4377 24.7637 34.9668C24.7637 34.496 25.1454 34.1143 25.6162 34.1143H26.6306C27.1081 34.1143 27.4925 34.5064 27.483 34.9839Z"
      fill="#878C9D"
    />
    <path
      d="M42.6672 23.0293H25.6162C25.1454 23.0293 24.7637 23.411 24.7637 23.8818C24.7637 24.3527 25.1454 24.7344 25.6162 24.7344H42.6672C43.138 24.7344 43.5197 24.3527 43.5197 23.8818C43.5197 23.411 43.138 23.0293 42.6672 23.0293Z"
      fill="#878C9D"
    />
    <path
      d="M53.7531 40.082H35.8497C35.3788 40.082 34.9971 40.4637 34.9971 40.9346C34.9971 41.4054 35.3788 41.7871 35.8497 41.7871H53.7531C54.224 41.7871 54.6057 41.4054 54.6057 40.9346C54.6057 40.4637 54.224 40.082 53.7531 40.082Z"
      fill="#878C9D"
    />
    <path
      d="M29.0265 40.082H25.6162C25.1454 40.082 24.7637 40.4637 24.7637 40.9346C24.7637 41.4054 25.1454 41.7871 25.6162 41.7871H29.0265C29.4973 41.7871 29.879 41.4054 29.879 40.9346C29.879 40.4637 29.4973 40.082 29.0265 40.082Z"
      fill="#878C9D"
    />
    <path
      d="M51.1926 46.0488H25.6162C25.1454 46.0488 24.7637 46.4305 24.7637 46.9014C24.7637 47.3722 25.1454 47.7539 25.6162 47.7539H51.1926C51.6635 47.7539 52.0452 47.3722 52.0452 46.9014C52.0452 46.4305 51.6635 46.0488 51.1926 46.0488Z"
      fill="#878C9D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.2458 14.7184H63.8259C64.7971 14.7184 65.8523 15.6046 65.8593 17.0484V53.112C66.6802 53.1349 67.486 53.2188 68.272 53.3595V17.0435C68.2627 14.4247 66.2783 12.3057 63.8259 12.3057H21.2458C18.7934 12.3057 16.7997 14.4247 16.7997 17.0435V71.9083C16.7997 74.527 18.7934 76.6461 21.2458 76.6461H50.9539C50.5615 75.8754 50.2289 75.0691 49.9624 74.2333H21.2458C20.2663 74.2333 19.2124 73.3393 19.2124 71.9083V17.0435C19.2124 15.6124 20.2663 14.7184 21.2458 14.7184Z"
      fill="#4D5160"
    />
    <defs>
      <clipPath id="clip0_6471_16664">
        <rect
          width="26.4"
          height="26.4"
          fill="white"
          transform="translate(52.8 56.4004)"
        />
      </clipPath>
      <clipPath id="clip1_6471_16664">
        <rect
          width="14.144"
          height="14.144"
          fill="white"
          transform="translate(59.1362 62.3203)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default Paperless;
